import { startTask, startTime, stopTime, finishTime, initTime, runLocked } from "./utils/timeManager.js";
import { applySheets } from "../../../app/utils/styleCache.js";
import { hasPermission } from "../../../app/auth.js";

export class AppTime extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.isMounted = false;
    }

    connectedCallback() {
        this.shadowRoot.innerHTML = `
            <style>:host { opacity: 0; }</style>
            <div class="content">
                <div class="cards">
                    <app-card id="cardWork"  label="Gesamte Arbeitszeit" value="--:--:--" sub="Aktuell: --:--:--" accent></app-card>
                    <app-card id="cardBreak" label="Gesamte Pausenzeit"  value="--:--:--" sub="Aktuell: --:--:--"></app-card>
                    <app-card id="cardStart" label="Startzeit"           value="--:--"    sub="Heute"></app-card>
                    <app-card id="cardEnd"   label="Endzeit"             value="--:--"    sub="Noch aktiv"></app-card>
                </div>
                <div class="timeSection">
                    <div class="timeItem">
                        <div class="timeItemLabel">Status</div>
                        <div class="timeItemValue" id="statusValue">--</div>
                    </div>
                    <div class="timeSep"></div>
                    <div class="timeItem">
                        <div class="timeItemLabel">Letzter Stop</div>
                        <div class="timeItemValue" id="lastStopValue">--:--</div>
                    </div>
                    <div class="timeSpacer"></div>
                    <button class="btn primary" id="startTaskButton" style="margin-right: 10px" disabled><i class="fa-solid fa-stopwatch"></i> Aufgabe beginnen</button>
                    <div class="btns">
                        <button class="btn primary" id="startButton" disabled><i class="fa-solid fa-play"></i> Start</button>
                        <button class="btn warning"  id="stopButton" disabled><i class="fa-solid fa-pause"></i> Pause</button>
                        <button class="btn danger"   id="finishButton" disabled><i class="fa-solid fa-stop"></i> Feierabend</button>
                    </div>
                </div>
            </div>
        `;

        this.isMounted = true;

        const root = this.shadowRoot;

        this.cardWork        = root.querySelector("#cardWork");
        this.cardBreak       = root.querySelector("#cardBreak");
        this.cardStart       = root.querySelector("#cardStart");
        this.cardEnd         = root.querySelector("#cardEnd");
        this.status          = root.querySelector("#statusValue");
        this.lastStopValue   = root.querySelector("#lastStopValue");
        this.startTaskButton = root.querySelector("#startTaskButton");
        this.startButton     = root.querySelector("#startButton");
        this.stopButton      = root.querySelector("#stopButton");
        this.finishButton    = root.querySelector("#finishButton");

        if (!hasPermission("Entries.Create")) {
            this.startTaskButton.style.display = "none";
        }

        root.querySelector("#startTaskButton").addEventListener("click", () => runLocked(startTask));
        root.querySelector("#startButton").addEventListener("click",     () => runLocked(startTime));
        root.querySelector("#stopButton").addEventListener("click",      () => runLocked(() => stopTime()));
        root.querySelector("#finishButton").addEventListener("click",    () => runLocked(finishTime));

        this.ready = applySheets(this.shadowRoot, [
            "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css",
            "components/features/app-time/app-time.css",
        ]).then(() => new Promise(resolve => requestAnimationFrame(resolve)));
    }
}

customElements.define("app-time", AppTime);
